import notify from './notify';

export const catchError = (e: any): void => {
  console.log('in catch error');
  notify({
    message: e.message,
    type: 'error',
  });
};
